module.exports = class MenuToggle {

    constructor(button) {

        this.button = button;

        button.addEventListener("click", this.Toggle.bind(this));

        document.addEventListener("keydown", (event) => {

            switch (event.keyCode) {

                case 27: this.Close(); break;

            }

        });

    }

    IsOpened() {

        return document.body.dataset.menuOpened;

    }

    Toggle() {

        if (this.IsOpened()) {

            this.Close();

        } else {

            this.button.dataset.open         = 1;
            document.body.dataset.menuOpened = 1;

            document.body.addEventListener("click", (event) => {

                if (this.IsOpened()) {

                    if (!(document.querySelector("header.mobile").contains(event.target) || this.button.contains(event.target))) {

                        event.preventDefault();
                        event.stopPropagation();

                        this.Close();

                    }


                }

                return true;

            });

        }

    }

    Close() {

        delete this.button.dataset.open;
        delete document.body.dataset.menuOpened;

    }
}